var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSilverstages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 111,
    viewBox: "0 0 96 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.5186,
    width: 95.9718,
    height: 100.481,
    fill: "url(#paint0_linear_10204_4282)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0871 0.716797H95.9718V10.5198H0L13.0871 0.716797Z",
    fill: "#D381DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0009 82.5098V81.8359C33.0009 79.6875 33.3524 77.7539 34.0555 76.0352C34.7587 74.2969 35.6669 72.7441 36.7802 71.377C37.913 69.9902 39.1239 68.7695 40.413 67.7148C41.702 66.6406 42.9325 65.6836 44.1044 64.8438C46.5653 63.0859 48.4208 61.4844 49.6708 60.0391C50.9403 58.5742 51.5751 56.9336 51.5751 55.1172C51.5751 51.4844 49.5829 49.668 45.5985 49.668C44.0165 49.668 42.62 49.9219 41.4091 50.4297C40.1981 50.9375 39.2216 51.4453 38.4794 51.9531C38.0497 52.2461 37.7079 52.373 37.454 52.334C37.2001 52.2949 36.9364 52.0312 36.663 51.543L34.1727 47.1777C33.8212 46.5723 33.9286 46.0742 34.495 45.6836C35.5888 44.9414 37.1708 44.1895 39.2411 43.4277C41.3309 42.666 44.0458 42.2852 47.3856 42.2852C51.663 42.2852 55.0028 43.3594 57.4052 45.5078C59.8075 47.6562 61.0087 50.5566 61.0087 54.209C61.0087 56.7676 60.5009 58.9746 59.4852 60.8301C58.4696 62.6855 57.1513 64.3262 55.5302 65.752C53.9091 67.1777 52.1708 68.5352 50.3153 69.8242C48.4208 71.1328 46.7509 72.4316 45.3055 73.7207C43.8602 75.0098 43.1376 76.2109 43.1376 77.3242H58.3134C58.7821 77.3242 59.1337 77.4023 59.368 77.5586C59.8759 77.9102 60.4032 78.3301 60.9501 78.8184C61.497 79.3066 62.0731 79.8926 62.6786 80.5762C62.8739 80.8301 62.9716 81.0254 62.9716 81.1621C62.9716 81.3379 62.8739 81.5332 62.6786 81.748C62.0731 82.4316 61.497 83.0176 60.9501 83.5059C60.4032 83.9941 59.8759 84.4141 59.368 84.7656C59.0946 84.9219 58.743 85 58.3134 85H35.1688C34.329 85 33.7528 84.7852 33.4403 84.3555C33.1473 83.9062 33.0009 83.291 33.0009 82.5098Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10204_4282",
    x1: 47.9859,
    y1: 10.5186,
    x2: 47.9859,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA10E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680B74"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverstages);
export default __webpack_public_path__ + "static/media/silverstages.8d93b45db1e3c0a1a0e728396c8606e3.svg";
export { ForwardRef as ReactComponent };